import React from 'react';
import { ValedictoryCeremony2025 } from '../views';

const AccountGeneralPage = () => {
  return <ValedictoryCeremony2025/>;
};

export default AccountGeneralPage;